import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../../../nodeIds';

export const adrenalGlandDisorder: AnswerPathTreeNode = {
  path: 'adrenalGlandDisorder',
  children: [{ path: 'details', nodeId: NodeIds.healthInsuredAdrenalGlandDisorderDetails }],
};
